import React, { useContext } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { RouteResolver } from "./routes/RouteResolver";
import { Context } from "./store/GlobalStore";

import CssBaseline from "@material-ui/core/CssBaseline";

interface State {
  theme: any;
}

export const App = (props: any, state: State) => {
  const { store } = useContext(Context);
  return (
    <ThemeProvider theme={store.theme}>
      <CssBaseline />
      <RouteResolver></RouteResolver>
    </ThemeProvider>
  );
};
